import api from "../../client";
import { PeopleDetailAccountVisibilityResponseData } from "../../types/people";

export const getAccountVisibilities = async (id: string | undefined) => {
  const { data } = await api.get<PeopleDetailAccountVisibilityResponseData>(
    `/profile/${id}/account-visibilities`,
  );

  return data;
};

export const createAccountVisibility = async (id: string, payload: any) => {
  const { data } = await api.post<PeopleDetailAccountVisibilityResponseData>(
    `/profile/${id}/account-visibility`,
    payload,
  );

  return data;
};

export const deleteAccountVisibility = async (visibilityId: string) => {
  const { data } = await api.delete<PeopleDetailAccountVisibilityResponseData>(
    `/profile/account-visibility/${visibilityId}`,
  );

  return data;
};
